module.exports = __webpack_public_path__ + "static/img/login_pic1.b6b45bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login_pic1.png
// module id = Hi+3
// module chunks = 1